import { render, staticRenderFns } from "./StaffpayoutDetails.vue?vue&type=template&id=e5ddc3d2&"
import script from "./StaffpayoutDetails.vue?vue&type=script&lang=js&"
export * from "./StaffpayoutDetails.vue?vue&type=script&lang=js&"
import style0 from "./StaffpayoutDetails.vue?vue&type=style&index=0&id=e5ddc3d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports